import styled, { css } from 'styled-components';

import { Tag, breakpoints, theme } from '@notino/react-styleguide';

export const StyledTag = styled(Tag)<{ newDesign: boolean }>`
  @media (max-width: ${breakpoints.sm}) {
    font-size: 0.75rem !important;
  }
  ${({ newDesign, tagType }) =>
    newDesign &&
    css`
      ${tagType === 'corner'
        ? css`
            top: -2px;
            right: -2px;
          `
        : ''}
      text-transform: none;
      ${theme.typography.labelSmall}
    `}
`;

// This wraps around all visualized tags so they stay together
export const StyledTagWrapper = styled.div<{ nowrapLg: boolean }>`
  @media (min-width: ${breakpoints.lg}) {
    ${(props) => (props.nowrapLg ? 'white-space: nowrap;' : '')}
  }
`;
